{
    "MivPq": {
        "position": {
            "x": 9,
            "y": 4,
            "z": 1
        },
        "key": "MivPq",
        "tag": "badspawn"
    }
}